export function obj2parameter(obj: { [key: string]: any }) {
  return Object.keys(obj)
    .map((k) => `${k}=${obj[k]}`)
    .join('&');
}
